import { clearModuleCache } from "@/lib/moduleCache";
import { clearMailOfflineCache } from "@/mail/offlineCache";

const OWNER_KEY = "atw-hub-cache-owner";

/**
 * Device caches survive sign-out so the same person reopens Hub instantly. When a
 * different account signs in on this device, wipe them before any module paints.
 */
export function claimDeviceCaches(email: string): void {
  const owner = email.trim().toLowerCase();
  if (!owner) return;
  let previous: string | null = null;
  try {
    previous = localStorage.getItem(OWNER_KEY);
    localStorage.setItem(OWNER_KEY, owner);
  } catch {
    return;
  }
  if (previous && previous !== owner) {
    try {
      localStorage.removeItem("atw-hub-mail-bootstrap");
      localStorage.removeItem("atw-hub-mail-nav");
      for (let i = localStorage.length - 1; i >= 0; i -= 1) {
        const key = localStorage.key(i);
        if (key?.startsWith("atw-hub-mc:")) localStorage.removeItem(key);
      }
    } catch {
      /* ignore */
    }
    void clearModuleCache();
    void clearMailOfflineCache();
  }
}
